import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["id", "data-bs-autohide"]
const _hoisted_2 = { class: "toast-header" }
const _hoisted_3 = {
  key: 0,
  class: "me-auto"
}
const _hoisted_4 = {
  key: 1,
  class: "me-auto"
}
const _hoisted_5 = { class: "text-muted" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "toast",
  "aria-label": "Close"
}, null, -1)
const _hoisted_7 = {
  key: 0,
  class: "toast-body"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 2,
  class: "progress"
}
const _hoisted_11 = ["aria-valuenow"]
const _hoisted_12 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.event)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["toast show", _ctx.toastClass]),
        id: _ctx.event.id,
        "data-bs-autohide": _ctx.needHide,
        "data-bs-delay": "5000",
        role: "alert",
        "aria-live": "assertive",
        "aria-atomic": "true"
      }, [
        _createElementVNode("div", _hoisted_2, [
          (!_ctx.event.toTranslate)
            ? (_openBlock(), _createElementBlock("strong", _hoisted_3, _toDisplayString(_ctx.event.title), 1))
            : _createCommentVNode("", true),
          (_ctx.event.toTranslate && _ctx.event.title)
            ? (_openBlock(), _createElementBlock("strong", _hoisted_4, _toDisplayString(_ctx.$t(_ctx.event.title)), 1))
            : _createCommentVNode("", true),
          _createElementVNode("small", _hoisted_5, _toDisplayString(_ctx.fromTime), 1),
          _hoisted_6
        ]),
        (_ctx.event.content && _ctx.event.content.data)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (_ctx.event.content.type === 'text' && !_ctx.event.toTranslate)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.event.content.data.text), 1))
                : _createCommentVNode("", true),
              (_ctx.event.content.type === 'text' && _ctx.event.toTranslate)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.$t(
            _ctx.event.content.data.text as string,
            _ctx.event.content.data.textContent as any
          )), 1))
                : _createCommentVNode("", true),
              (_ctx.event.content.type === 'progress')
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("div", {
                      class: "progress-bar progress-bar-striped progress-bar-animated",
                      role: "progressbar",
                      "aria-valuenow": 
            ((_ctx.event.content.data.progress as number) / (_ctx.event.content.data.total as number)) * 100
          ,
                      style: _normalizeStyle(`width: ${
            ((_ctx.event.content.data.progress as number) / (_ctx.event.content.data.total as number)) * 100
          }%`),
                      "aria-valuemin": "0",
                      "aria-valuemax": "100"
                    }, null, 12, _hoisted_11)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.event.content.type === 'progress')
                ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.event.content.data.progress) + " / " + _toDisplayString(_ctx.event.content.data.total), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ], 10, _hoisted_1))
    : _createCommentVNode("", true)
}